import React, { useState } from "react";
import cn from "classnames";
import styles from "./Faq.module.sass";
import Item from "./Item";
import Dropdown from "../../../components/Dropdown";

const items = [
  {
    title: "Général",
    items: [
      {
        title: "Qu'est-ce que Edutio ?",
        content: "Edutio est une plateforme SaaS innovante conçue pour les centres de formation et les CFA. Elle simplifie la gestion administrative, automatise vos démarches et centralise toutes vos données dans un outil unique et intuitif."
      },
      {
        title: "À qui s'adresse cette solution ?",
        content: "Edutio est pensé pour les centres de formation (CFA), les organismes accueillant des apprentis, les structures de formation continue et les professionnels de la reconversion. Si vous souhaitez gagner du temps, réduire les erreurs et mieux suivre vos apprenants, Edutio est fait pour vous."
      },
      {
        title: "Puis-je essayer gratuitement ?",
        content: "Oui. Nous proposons une période d'essai gratuite de 14 jours pour découvrir toutes les fonctionnalités de la plateforme, sans engagement. Vous pouvez également réserver une démonstration personnalisée avec notre équipe."
      },
      {
        title: "Mes données sont-elles sécurisées ?",
        content: "Absolument. Vos données sont hébergées en France, cryptées et conformes aux normes RGPD. Nous mettons en place les meilleures pratiques de cybersécurité pour garantir la confidentialité et l’intégrité de vos informations."
      }
    ]
  },
  {
    title: "Fonctionnalités",
    items: [
      {
        title: "Quelles sont les principales fonctionnalités ?",
        content: "Edutio automatise vos contrats et conventions, se connecte directement aux OPCO, propose des tableaux de bord en temps réel, intègre la signature électronique et offre un suivi détaillé de chaque apprenant et dossier."
      },
      {
        title: "Comment fonctionne l'automatisation ?",
        content: "Notre technologie génère automatiquement tous vos documents (CERFA, conventions, avenants) à partir des données saisies. Fini les ressaisies et les erreurs : tout est pré-rempli et vérifié en quelques secondes."
      },
      {
        title: "Y a-t-il une application mobile ?",
        content: "La plateforme est entièrement accessible depuis tous vos appareils. Une interface mobile optimisée permet de suivre vos dossiers et vos apprenants en déplacement, en toute simplicité."
      },
      {
        title: "Comment suivre mes performances ?",
        content: "Grâce à nos tableaux de bord, vous disposez d’indicateurs clairs : taux de validation, délais de traitement, paiements en attente, statistiques détaillées. Vous gardez une vision complète de vos activités en temps réel."
      }
    ]
  },
  {
    title: "Support",
    items: [
      {
        title: "Quel support proposez-vous ?",
        content: "Notre équipe est disponible à chaque étape : accompagnement à la mise en place, formation de vos équipes, support technique réactif et suivi régulier pour optimiser votre utilisation."
      },
      {
        title: "Combien de temps pour la mise en place ?",
        content: "La mise en place est rapide et simple : nous nous occupons de tout, de la migration de vos données existantes à la formation de vos équipes. En général, vous êtes opérationnels sous 48h."
      },
      {
        title: "Puis-je intégrer mes outils existants ?",
        content: "Oui. Edutio s’intègre facilement avec vos logiciels actuels (comptabilité, gestion, pédagogie). Notre API ouverte permet une connexion fluide à vos outils préférés."
      },
      {
        title: "Comment migrer mes données actuelles ?",
        content: "Notre équipe technique gère entièrement la migration de vos données. Le processus est sécurisé, rapide et sans interruption pour vos équipes ni vos apprenants."
      },
      {
        title: "Une formation est-elle incluse ?",
        content: "Oui. Une formation complète est incluse dans votre abonnement. Nos experts accompagnent vos équipes pour qu’elles soient autonomes dès la première utilisation."
      }
    ]
  }
  
];

const Team = () => {
  const options = [];
  items.map((x) => options.push(x.title));

  const [category, setCategory] = useState(options[0]);

  return (
    <div className={cn("section-border-top", styles.section)}>
      <div className={cn("container", styles.container)}>
        <div className={styles.top}>
          <div className={cn("stage-small", styles.stage)}>
            Questions fréquentes
          </div>
          <h2 className={cn("h2", styles.title)}>FAQ – Questions fréquentes</h2>
          <div className={styles.info}>
            Découvrez les réponses aux questions les plus courantes sur notre plateforme de gestion des contrats d'alternance ou <a href="/contact">Contactez notre support</a>
          </div>
          <div className={styles.nav}>
            {items.map((x, index) => (
              <button
                className={cn(styles.btn, {
                  [styles.active]: x.title === category,
                })}
                onClick={() => setCategory(x.title)}
                key={index}
              >
                {x.title}
              </button>
            ))}
          </div>
          <Dropdown
            className={styles.dropdown}
            value={category}
            setValue={setCategory}
            options={options}
          />
        </div>
        <div className={styles.list}>
          {items
            .find((x) => x.title === category)
            .items.map((x, index) => (
              <Item item={x} key={index} />
            ))}
        </div>
      </div>
    </div>
  );
};

export default Team;
